import { useNavigate } from 'react-router-dom';
import { 
  FaLaptopCode, 
  FaChartLine, 
  FaUserMd, 
  FaIndustry,
  FaHeadset,
  FaBriefcase,
  FaUsers,
  FaMicrochip,
  FaSearch,
  FaStore,
  FaBuilding
} from 'react-icons/fa';
import './PopularCategories.css';

function PopularCategories() {
  const navigate = useNavigate();

  const categories = [
    {
      icon: <FaChartLine />,
      title: 'Accounting & Finance',
      value: 'accounting_finance',
      count: '180+ Jobs',
      description: 'Financial Management & Analysis',
      color: '#0b482b'
    },
    {
      icon: <FaLaptopCode />,
      title: 'Data Analyst',
      value: 'data_analyst',
      count: '150+ Jobs',
      description: 'Data Science & Analytics',
      color: '#0b482b'
    },
    {
      icon: <FaBuilding />,
      title: 'Banking',
      value: 'banking',
      count: '120+ Jobs',
      description: 'Banking & Financial Services',
      color: '#0b482b'
    },
    {
      icon: <FaHeadset />,
      title: 'BPO',
      value: 'bpo',
      count: '200+ Jobs',
      description: 'Business Process Outsourcing',
      color: '#0b482b'
    },
    {
      icon: <FaBriefcase />,
      title: 'Business Development',
      value: 'business_development',
      count: '160+ Jobs',
      description: 'Sales & Business Growth',
      color: '#0b482b'
    },
    {
      icon: <FaHeadset />,
      title: 'Customer Support',
      value: 'customer_support',
      count: '140+ Jobs',
      description: 'Customer Service & Support',
      color: '#0b482b'
    },
    {
      icon: <FaUserMd />,
      title: 'Health Care',
      value: 'health_care',
      count: '130+ Jobs',
      description: 'Medical & Healthcare Services',
      color: '#0b482b'
    },
    {
      icon: <FaUsers />,
      title: 'Management',
      value: 'management',
      count: '110+ Jobs',
      description: 'Leadership & Administration',
      color: '#0b482b'
    },
    {
      icon: <FaChartLine />,
      title: 'Digital Marketing',
      value: 'digital_marketing',
      count: '170+ Jobs',
      description: 'Online Marketing & Advertising',
      color: '#0b482b'
    },
    {
      icon: <FaMicrochip />,
      title: 'Electrical & Electronics',
      value: 'electrical_electronics',
      count: '90+ Jobs',
      description: 'Electrical Engineering & Electronics',
      color: '#0b482b'
    },
    {
      icon: <FaIndustry />,
      title: 'Engineering & Technology',
      value: 'engineering_technology',
      count: '150+ Jobs',
      description: 'Technical & Engineering Services',
      color: '#0b482b'
    },
    {
      icon: <FaUserMd />,
      title: 'Healthcare',
      value: 'healthcare',
      count: '120+ Jobs',
      description: 'Medical & Healthcare Services',
      color: '#0b482b'
    },
    {
      icon: <FaUsers />,
      title: 'Human Resource',
      value: 'human_resource',
      count: '100+ Jobs',
      description: 'HR & Talent Management',
      color: '#0b482b'
    },
    {
      icon: <FaLaptopCode />,
      title: 'IT & Software',
      value: 'it_software',
      count: '250+ Jobs',
      description: 'Software Development & IT Services',
      color: '#0b482b'
    },
    {
      icon: <FaChartLine />,
      title: 'Marketing',
      value: 'marketing',
      count: '140+ Jobs',
      description: 'Marketing & Communications',
      color: '#0b482b'
    },
    {
      icon: <FaSearch />,
      title: 'Research & Development',
      value: 'research_development',
      count: '80+ Jobs',
      description: 'R&D & Innovation',
      color: '#0b482b'
    },
    {
      icon: <FaStore />,
      title: 'Retail & Ecommerce',
      value: 'retail_ecommerce',
      count: '160+ Jobs',
      description: 'Retail Sales & Online Commerce',
      color: '#0b482b'
    }
  ];

  const handleCategoryClick = (categoryValue) => {
    // Navigate to the search page with the category as a URL parameter
    navigate(`/search?category=${categoryValue}`);
  };

  return (
    <section className="popular-categories">
      <div className="container">
        <div className="section-header">
          <h2>Popular Job Categories</h2>
          <p>Explore opportunities in trending industries</p>
        </div>
        
        <div className="categories-grid">
          {categories.map((category, index) => (
            <div 
              key={index}
              className="category-card"
              onClick={() => handleCategoryClick(category.value)}
              style={{ cursor: 'pointer' }}
            >
              <div className="category-icon" style={{ color: category.color }}>
                {category.icon}
              </div>
              <h3>{category.title}</h3>
              <p className="category-count">{category.count}</p>
              <p className="category-description">{category.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PopularCategories; 